


import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastController } from '@ionic/angular';
// import { index, linkHorizontal } from 'd3';

import { IDropdownSettings } from "ng-multiselect-dropdown";
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { formatText } from 'src/app/shared/commen-function-file';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

interface AssetNode {
  id: any;
  assetName: string;
  children?: AssetNode[];
}
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-new-asset-employee',
  templateUrl: './new-asset-employee.component.html',
  styleUrls: ['./new-asset-employee.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class NewAssetEmployeeComponent implements OnInit {
  buttonColorName: any;
  updateData: any;
  userListDataForAsset: any;
  dropdownSettingsForBand: IDropdownSettings = {};
  dropdownSettingsForAsset: IDropdownSettings = {};
  dropdownSettingsForEmployee: IDropdownSettings = {};
  selectedEmployeeIdForReport: any;
  dropdownData: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserId: any | null;
  year: any;
  fiscalYear: any;
  todayDate: any;
  datedisplay: any
  isReadOnly = true;
  loggedInUserRole: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoles: any;
  dropdownSettings: IDropdownSettings = {};
  loggedInUserName: any;
  selectedYearForAsset: any;
  pmsYears: any = [];
  fromYear: any;
  toYear: any;
  formatedataVariable = formatText;
  constructor(private toastController: ToastController, private datePipe: DatePipe, public dialogRef: MatDialogRef<NewAssetEmployeeComponent>, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any, private encryptionService: EncryptionService, private config: Config, private httpService: HttpService,) {
    this.todayDate = new Date().toISOString().split('T')[0];
    console.log(data);

    this.datedisplay = this.datePipe;
    this.year = data?.year;
    this.fiscalYear = data?.fiscal_year;
    this.updateData = data?.data;
    console.log("this.updateData", this.updateData);
    if (this.data?.data != null) {
      this.selectedBand = this.updateData?.band;
      this.selectedEmployee = this.updateData?.employeeName;
      // this.selectedAssets = this.updateData?.assetId;
      console.log(this.selectedBand);
    }

  }
  assetOptions = [
    "RECEIVED_ASSET",
    "REPAIR_ASSET",
    "RETURNING_ASSET_DUE_TO_EXIT",
    "RECEIVED_AFTER_REPAIR"
  ];

  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getpmsyearlist();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    // this.allAssets = this.userListDataForAsset.users.map((asset: { assetName: any; }) => asset.assetName);




  }
  selectedAsset: any;



  selectedEmployee: any;
  selectedSubAsset: any;

  filteredEmployees: any[] = [];
  filteredAssets: any[] = [];
  selectedBand: any[] = [];
  // selectedAssets:any;
  //   // This function will be triggered when the asset (band) changes
  onAssetChange(event: any) {
    console.log(event);


  }

  //   // This function will be triggered when an employee is selected


  onBandChange(event: any) {
    console.log('Selected Bands:', this.selectedBand); // Log the selected values (array of bands)
    this.selectedBand = event.value;  // Store the selected bands in the array



  }


  onEmployeeChange() {
    console.log(this.selectedBand);

    this.userListDataForAsset.users = this.userListDataForAsset.users.filter((elm: any) => this.selectedBand.includes(elm.band))
    console.log(this.userListDataForAsset);



  }
  selectedAssets: any[] = [];

  allAssets: string[] = []; // Holds all asset names to handle "Select All"






  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);
      // this.getAllAssetData('bar')
      this.NewassetAllocationData();
    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForAsset = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      // this.getAllAssetData('bar')
      this.NewassetAllocationData();

    }
  }

  // Triggered when the asset dropdown is clicked
  onAssetClick() {
    console.log('Assets dropdown clicked');
    // You can handle other logic when dropdown is clicked, if needed
  }






  assetManagementHeader = [

    { label: 'Employee Name', isMandatory: false, sortingName: 'employeeName' },
    { label: 'Band', isMandatory: false, sortingName: 'band' },
    { label: 'Asset', isMandatory: true, sortingName: 'asset' },
    { label: ' Date Of joining', isMandatory: false, sortingName: 'reimbursementType' },


    { label: 'Action', isMandatory: false, sortingName: 'action' },


  ];






  AllAssetListingData: any[] = [];
  getbandListData: any[] = [];
  selectedBandformultiple: any[] = [];
  NewassetAllocationData() {
    console.log(this.httpService.checkAuthorityName);

    if (this.httpService.checkAuthorityName) {
      console.log(this.selectedYearForAsset);
      // this.httpService.callGetService(`${this.config.newJoiningEmployee}/${this.loggedInUserCompanyID}/${this.loggedInUserName}`)
      this.httpService.callGetService(`${this.config.newJoiningEmployee}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset}/${this.loggedInUserCompanyID}`)
        .subscribe((elm: any) => {
          let authorityData = elm.data.filter((elm: any) => elm.authorityName == this.loggedInUserName)
          this.AllAssetListingData = authorityData;
        })


    } else {
      console.log("+++++++++++++++++++++++++++++++++++++++++++++",this.selectedYearForAsset);
      this.httpService.callGetService(`${this.config.newJoiningEmployee}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset}/${this.loggedInUserCompanyID}`)
        .subscribe((elm: any) => {
          console.log(elm);
          console.log(this.httpService.checkAuthorityName);


          this.AllAssetListingData = elm.data;
          this.getbandListData = this.AllAssetListingData.map((ele: any, index: any) => ({
            id: index,
            name: ele.unassignedAssets,
          }));
          console.log(this.AllAssetListingData);


        })
    }


  }
  filterBandByAsset(asset: string) {
    // Replace this with your logic to filter bands based on the asset
    console.log(asset);

    return this.getbandListData.filter((band: any) => band.band === asset);
  }

  assets: any = [];
  allUsers: any[] = [];


  dropDownForband: any[] = [];
  dropDownForEmployee: any[] = [];
  finalTableListData: any[] = [];




  filteredData: any;

  updateAssetData(data: any) {

    console.log(data);


    // Flatten the selectedBandformultiple array and remove undefined values
    const singleArray = this.selectedBandformultiple.reduce((acc: any[], val: any[]) => acc.concat(val), []).filter((elm: any) => elm !== undefined);

    // Log the flattened array
    console.log(singleArray);

    // Filter unassignedAssets based on whether they are in singleArray
    let filteredAssets = data.unassignedAssets.filter((asset: any) => singleArray.includes(asset));

    // Filter assetIds based on the matching unassignedAssets
    let filteredAssetIds = data.assetIds.filter((_: any, index: number) => singleArray.includes(data.unassignedAssets[index]));

    console.log(filteredAssets); // ["Phone", "Mouse"]
    console.log(filteredAssetIds); // [178, 179] (o



    // Filter unassignedAssets and assetIds based on the matched indices
    this.filteredData = {
      ...data,
      unassignedAssets: data.unassignedAssets.filter((elm: any) => filteredAssets.includes(elm)),
      assetIds: data.assetIds.filter((elm: any) => filteredAssetIds.includes(elm))



      //-----------------------------------------employeeCommentDate---------------------------------------



      // if (existingIndex === -1) {
      //   // If not found, add a new object with updated data
      //   this.updatedAssetData.push({
      //     userId: updatedUser.userId,
      //     assetIds: updatedUser.assetIds,
      //     companyId: this.loggedInUserCompanyID,

      //   });
      // } else {
      //   // If found, update the existing object
      //   this.updatedAssetData[existingIndex] = {
      //     userId: updatedUser.userId,
      //     assetIds: updatedUser.assetIds,
      //     companyId: this.loggedInUserCompanyID,

      //   };
      // }
    }

  }




selecteAsset:boolean=true;
  updateDataByEmployee() {
    if (this.filteredData.assetIds.length == 0) {
      this.selecteAsset=false;
      return;
    }
    const formData = {
      "userId": this.filteredData.userId,
      "assetIds": this.filteredData.assetIds,
      "companyId": this.loggedInUserCompanyID,

    }


    this.httpService.callPostService(`${this.config.multipleAssetsnewJoiningEmployee}`, formData).subscribe((result: any) => {
      // console.log(result);
      // this.assetAllocationData();
      if (result) {
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: result.message,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });
        this.NewassetAllocationData()
        this.selectedBandformultiple = []
      }

    })

  }

  cancelData() {
    // Listen to the result and then perform actions
    this.dialogRef.afterClosed().subscribe((result) => {
      console.log('Dialog closed with result:', result);
      // Perform any additional logic based on the result
    });

    // Close the dialog
    this.dialogRef.close();
  }

}





